// extracted by mini-css-extract-plugin
export default {"textAreaBox":"TextArea_textAreaBox__vyGni","label":"TextArea_label__BE86m","labelDisabled":"TextArea_labelDisabled__C2Y8T"};